// Lookup helpers for page routes. Route data + default SEO live in
// shared/src/configs/pageRoutes.ts; shape types live in shared/src/types/configs/pageRoutes.ts.
import { DEFAULT_PAGE_SEO, pageRoutes } from '../configs/pageRoutes';
export const getSEOConfig = (normalizedPath) => {
    const route = pageRoutes.find((r) => r.normalizedPath === normalizedPath);
    if (!route?.seo) {
        return DEFAULT_PAGE_SEO;
    }
    return {
        title: route.seo.title ?? route.pageTitle,
        description: route.seo.description,
        image: route.seo.image ?? DEFAULT_PAGE_SEO.image,
        imageWidth: route.seo.imageWidth ?? DEFAULT_PAGE_SEO.imageWidth,
        imageHeight: route.seo.imageHeight ?? DEFAULT_PAGE_SEO.imageHeight,
    };
};
//# sourceMappingURL=getRoutes.js.map